import organisations from './organisations/index'

export default {
  namespaced: true,
  state: {
    ...organisations.state
  },
  getters: {
    ...organisations.getters
  },
  mutations: {
    ...organisations.mutations
  },
  actions: {
    ...organisations.actions,

    async clearContents({ commit, dispatch }, params) {
      commit('CLEAR_CONTENT', params)
    }
  }
}
